import axios from 'axios'
import { parseNumber, formatNumber } from 'libphonenumber-js'
import noCatchFetcher from './utils/noCatchFetcher'

export function verifyPhoneNumber(phone_number) {
  const formattedPhoneNumber = formatNumber(parseNumber(phone_number), 'E.164')
  return (dispatch) =>
    dispatch({
      type: 'CURRENT_USER_PHONE_NUMBER_VERIFY',
      payload: axios.post('/user/phone_number_verifications', {
        phone_number: formattedPhoneNumber,
      }),
    })
}

export function verifySMSCode(formValues) {
  const formattedPhoneNumber = formatNumber(
    parseNumber(formValues.phone_number),
    'E.164'
  )
  return (dispatch) =>
    dispatch({
      type: 'CURRENT_USER_SMS_CODE_VERIFY',
      payload: noCatchFetcher.post('/user/phone_number_verifications/verify', {
        ...formValues,
        phone_number: formattedPhoneNumber,
      }),
    })
}
